// extracted by mini-css-extract-plugin
export var hidden = "_p3-1";
export var visible = "_p3-0";